export const locale = {
    lang: 'es',
    data: {
      'LOGIN': {
        'AUTENTICACION': {
          'TITULO': 'Autenticacíon de dos pasos',
          'SUBTITULO': 'Para brindar mayor seguridad al ingresar a la plataforma, es necesario que realice la autenticación de dos pasos como se indica a continuación',
          'BOTONES': {
            'SIGUIENTE': 'Siguiente',
            'ANTERIOR': 'Anterior'
          },
          'PASOS': {
            '1': {
              'TITULO': 'Paso 1',
              'INSTRUCCION': 'Escanee el código QR con la aplicación móvil Autenticador de Google y haga clic en el botón siguiente',
              'REGISTRADO': 'Se detectó que su correo electrónico ya se encuentra registrado en la aplicación Google Authenticator, no es necesario escanear el código QR nuevamente, continue al siguiente paso'
            },
            '2': {
              'TITULO': 'Paso 2',
              'INSTRUCCION': 'Ingrese la clave proporcionada por Google Authenticator y haga clic en siguiente',
              'INPUT': 'Clave obtenida',
              'INFOPREVIA': {
                'INFO_1': 'Se detectó que ya ha accedido desde este equipo a la plataforma. No es necesario escanear el código QR nuevamente',
                'INFO_2': 'Sólo ingrese la clave proporcionada por Google Authenticator para su cuenta y haga clic en siguiente',
                'INFO_3': 'Si desea escanear nuevamente el código QR, haga clic en el botón Anterior',
                'INFO_4': 'Advertencia: al hacer esto, tendrá que vincular nuevamente su cuenta a Google Authenticator',
              }
            },
            '3': {
              'TITULO': 'Resultado',
              'INSTRUCCION': 'Ingrese la clave obtenida del código QR en el paso anterior y haga clic en siguiente',
              'VALIDANDO': 'Validando la clave introducida, espere un momento',
              'MAL': 'La clave es incorrecta o ha expirado, vuelva a introducir la clave e intente nuevamente',
              'BIEN': 'Ha completado correctamente la autenticación, a continuación ingresará a la plataforma'
            },
          }
        },
        'PASSWORD':{
          'AVISO':'Por favor, ingrese su correo electrónico y le enviaremos un correo con una liga para cambiar su contraseña',
          'BTN':'Enviar correo electrónico',
          'PLACERHOLDER':'Correo electrónico',
          'ERROR':'Correo electrónico no encontrado, por favor ingrese uno nuevo',
          'TRUE':'Correo electrónico enviado, por favor revise su bandeja de entrada',
          'MENSAJE':{
            'WAITING':'Please wait...',
            'OK':'OK',
          }
        },
        'RESET':{
          'LABEL01':'Por favor ingrese la nueva contraseña para el usuario: ',
          'LABEL02':'Contraseña',
          'LABEL03':'Repetir contraseña',
          'BTN':'Cambiar contraseña',
          'ERROR':'Error, no se encuentra el token',
          'NOPASSWORDMATCH':'La contraseña no coinciden',
          'CARACTERES':'Deben ser al menos 3 carácteres',
          'SUCCESSCHANGE':'Su contraseña ha sido cambiada correctamente'
        },
        'LANDING': {
          'MENSAJE': 'Bienvenido',
          'NAVEG': ''
          //'NAVEG': 'Se recomienda el uso del navegador <a class="linkChrome" href="https://www.google.com/intl/es-419/chrome/" target="blank">Google Chrome</a>'
        },
        'MODALES': {
          'AVISO1': {
            'TITULO': 'Aviso Importante.',
            // 'TEXTO': `Estimado usuario:<br><br>
            // Se le comunica que, con el objetivo de poder brindar un mejor servicio, se realizar&aacute; una actualizaci&oacute;n de la plataforma Cultural GO para optimizar su funcionamiento.<br><br>
            // La actualizaci&oacute;n se llevar&aacute; a cabo el d&iacute;a <strong>miercoles 1 de abril, a partir de las 20:00, hasta las 08:00 del d&iacute;a jueves 2 de abril</strong>. Durante ese periodo la plataforma permanecer&aacute; inactiva. Sin embargo, las encuestas vigentes seguir&aacute;n activas. <br><br>
            // Agradecemos su comprensi&oacute;n.`
            'TEXTO': `Estimado usuario:<br><br>
            Se le comunica que, con el objetivo de poder brindar un mejor servicio, se realizar&aacute; una actualizaci&oacute;n de la plataforma Cultural GO para optimizar su funcionamiento.<br><br>
            La actualizaci&oacute;n se llevar&aacute; a cabo el d&iacute;a <strong>viernes 23 de julio, a partir de las 23:59, hasta las 23:59 del d&iacute;a sábado 24 de julio</strong>. Durante ese periodo la plataforma permanecer&aacute; inactiva. Sin embargo, las encuestas vigentes seguir&aacute;n activas. <br><br>
            Agradecemos su comprensi&oacute;n.`
          }
        },
        'FORM': {
          'FORGOTPASSWORD':'Recuperar contraseña',
          'LOGIN':'Iniciar sesión',
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'EMAIL': 'Correo electrónico:',
            'PASSWORD': 'Contraseña:',
            'LANGSEL': 'Elija un idioma:'
          },
          'VAL': {
            'NOTEMAIL': 'Se necesita el correo electrónico',
            'INVEMAIL': 'Correo electrónico no válido',
            'CARACT_EMA': '  El campo no permite los sig.  caracteres /&¿+#$%([=])*?"<>:\'',
            // 'PASS': 'Se necesita la contraseña',
            'PASS': 'Contraseña invalida',
          },
          'SIGNIN': 'GO!',
          'CAMBIALOGO': 'Presione aquí para cambiar el logo de su compañía',
          'CARGAOK': 'El logotipo de su empresa se cargó correctamente',
          'CARGANULL': 'Ocurrió un error al cargar el logotipo de su empresa',
          'CARGAERROR': 'El formato del archivo seleccionado no es correcto. Solo se aceptan los formatos: jpg, png, gif'
        }
      },
      'LOGIN-ENCUESTADOR':{
        'FORM': {
          'TITULO': 'INGRESE A SU CUENTA',
          'INPUT':{
            'PASSWORD': 'Contraseña:',
            'LANGSEL': 'Elija un idioma:',
            'LOGIN':'Iniciar Sesión',
          },

      },
      'INTRO-LOGIN':{
        'TITULO':'INSTRUCCIONES',
        'TEXT1':'Great Place to Work® Institute. te da la bienvenida para responder de forma 100% confidencial tu encuesta de clima laboral.',
        'TEXT2':'Confidencialidad',
        'TEXT3':'En el Instituto:',
        'TEXT4':'Administramos, procesamos, analizamos estadísticamente las respuestas por organización y área.',
        'TEXT5':'Generamos resultados globales que indiquen las acciones de mejora en el clima de la organización.',
        'TEXT6':'no conocerá las respuestas individuales',
        'TEXT7':'Las respuestas individuales son estrictamente confidenciales.',
        'TEXT8':'Denuncias y Sugerencias',
        'TEXT9':' Está estrictamente prohibido que:',
        'TEXT10':'se te influencie, penalice o impida de cualquier forma responder libremente la encuesta.',
        'TEXT11':'Ponemos a tu disposición el siguiente correo para hacer denuncias o sugerencias:',
        'TEXT12':'mx_transparencia@greatplacetowork.com',
        'TEXT13':'Instrucciones:',
        'TEXT14':'1. Ingresa tu ',
        'TEXT15':'número de empleado + año de nacimiento.',
        'TEXT16':'2. No dejes espacios en blanco.',
        'TEXT17':'3. Da clic en Iniciar.',
        'TEXT18':'¡Ayúdanos a contestar la encuesta de Great Place to Work® Institute!',
      }
    },
    'LOADING':{
      'TEXT_WELCOM':'Bienvenido a CulturalGo',
      'TEXT_CHANGE':'Cargando información...',
    }

   }
};
